<template>
  <div class="folder-main">
    <div class="folder-index">
      <div
        class="index-item"
        @click="backIndex(item, index)"
        v-for="(item, index) in folderIndexList"
        :key="index"
      >
        {{ item.name }}
        <span v-show="index < folderIndexList.length - 1"></span>
      </div>
    </div>
    <div class="folder-list">
      <div class="folder-count">
        <el-checkbox @change="selectAll" v-model="checkAll">
          <span v-show="checkList.length > 0">已选择{{ checkList.length }}项 /</span>
          共{{ count }}项
        </el-checkbox>

        <div class="tools">
          <el-button
            type="primary"
            size="small"
            v-show="hasFolder && checkList.length > 0"
            @click="openSecurity"
          >保密操作</el-button>
          <el-button type="primary" size="small" @click="upload">上传</el-button>
          <input
            hidden
            type="file"
            :accept="allowSuffixList"
            multiple
            ref="uploadFile"
            @change="getFile"
          />
          <el-button
            type="danger"
            size="small"
            @click="deleteFileAndFolder"
            plain
            v-show="checkList.length > 0"
            icon="el-icon-delete"
            class="delete"
          >删除</el-button>
          <el-button
            type="primary"
            size="small"
            v-show="hasFolder && checkList.length === 1"
            plain
            @click="downloadFile"
            icon="el-icon-download"
          >下载</el-button>
          <a
            v-show="false"
            ref="fileDownload"
            :href="filePath"
            download
            target="_blank"
            class="href"
          ></a>
        </div>
      </div>
      <div class="folder-main-list">
        <div class="overflow">
          <el-checkbox-group @change="changeCheckAll" v-model="checkList">
            <div
              class="folder-item"
              :class="{ active: item.isCheck, 'image-item': item.is_file, 'security': item.isSecrecy }"
              v-for="(item, index) in folderList"
              :key="index"
            >
              <el-checkbox
                class="spe"
                :value="item.id"
                :label="item.id"
                @change="checkStatus(item)"
              ></el-checkbox>
              <i class="label" v-show="item.fileSuf === 'gif'">GIF</i>
              <img
                v-if="!item.is_file"
                @click="toFolder(item)"
                :src="item.is_children ? folderIcon : folderNoneIcon"
                alt
              />
              <div v-if="item.is_file" @click="openDetail(item)" class="image-box">
                <img :src="item.fileThumbnailPath ? item.fileThumbnailPath : unknowImage" alt />
              </div>
              <p
                @click="openDetail(item)"
                v-if="item.is_file"
                :title="item.fileDescription"
              >{{ item.fileDescription }}</p>
              <p
                @click="toFolder(item)"
                v-if="!item.is_file"
                :title="item.menuName"
              >{{ item.menuName }}</p>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <el-dialog
      class="mask"
      title
      :visible.sync="securityShow"
      width="600px"
      top="0"
      :show-close="false"
    >
      <div class="security-box">
        <h3 class="title">保密设置</h3>
        <div class="security-main">
          <img v-show="toolsIndex === 0" src="../assets/images/security-image.png" alt />
          <img v-show="toolsIndex === 1" src="../assets/images/security-open-image.png" alt />
          <div class="setting-box">
            <div class="setting-tools">
              <a
                class="tools-button"
                :class="{ active: toolsIndex === index }"
                @click="changeButtonIndex(index)"
                v-for="(item, index) in toolsButtonList"
                :key="index"
              >{{ item }}</a>
            </div>
            <div class="time-box">
              <p>保密截止时间：</p>
              <el-date-picker
                size="small"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :disabled="toolsIndex === 1"
                v-model="securityTime"
                :picker-options="pickerOptions"
                type="date"
                placeholder="永久"
              ></el-date-picker>
            </div>
          </div>
        </div>
        <div class="tools">
          <el-button size="small" @click="securityShow = false">取 消</el-button>
          <el-button type="primary" size="small" @click="applySecurity">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <upload-process-list
      @close="closeProcessList"
      @security="securityAll"
      v-show="fileInfoList.length > 0 && processShow"
      :list="fileInfoList"
    ></upload-process-list>
    <image-detail
      @wakeAdjust="wakeAdjust"
      @update-file="refreshImageDetail"
      :drawer="detailShow"
      :detail="detailData"
      @closeDrawer="detailShow = false"
    ></image-detail>
  </div>
</template>
<script>
import ImageDetail from "./ImageDetail";
import UploadProcessList from "./UploadProcessList";
import {
  getFolderList,
  getFileDetail,
  deleteFileAndFolder,
  getOSSConfig,
  uploadFileToOSS,
  writeUploadLog,
  downloadFile,
  getAllFileList,
  securityFile
} from "../assets/js/api";
import { PromiseWidget } from "../assets/js/tools";
import FolderIcon from "../assets/images/folder-big-icon.png";
import FolderNoneIcon from "../assets/images/folder-big-none-icon.png";
import unknowImage from "../assets/images/unknow-format.png";
import { UPLOAD_ALLOW_SUFFIX_LIST } from "../assets/js/config";
export default {
  components: { ImageDetail, UploadProcessList },
  props: {
    folderIndex: {
      type: Number,
      default: -1
    },
    update: {
      type: Number,
      default: -1
    },
    folderPath: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      securityShow: false,
      folderIcon: FolderIcon,
      folderNoneIcon: FolderNoneIcon,
      unknowImage: unknowImage,
      folderIndexList: [{ name: "全部", index: -1 }],
      folderList: [],
      checkAll: false,
      checkList: [],
      detailShow: false,
      detailData: {},
      treeList: [],
      dialogUploadShow: false,
      OSSConfig: {},
      filePath: "",
      fileList: [],
      fileInfoList: [],
      allowSuffixList: UPLOAD_ALLOW_SUFFIX_LIST.join(","),
      processShow: false,
      toolsButtonList: ["保密", "公开"],
      toolsIndex: 0,
      securityTime: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
      },
      oldDetail: {}
    };
  },
  watch: {
    folderIndex(val) {
      val !== -1 && this.getFolderList(val);
    },
    update(val) {
      this.getAllFileList();
      this.folderIndexList = [];
      // this.getFolderList();
    },
    folderPath(val) {
      this.folderIndexList = val;
    }
  },
  computed: {
    count() {
      return this.folderList.length;
    },
    hasFolder() {
      const temp = [];
      this.folderList.map(item => {
        if (this.checkList.includes(item.id)) {
          temp.push(item);
        }
      });
      return temp.filter(item => !item.is_file).length === 0;
    },
    folderId: {
      get() {
        return this.$store.state.folderId;
      },
      set(value) {
        this.$store.commit("changeFolderId", value);
      }
    }
  },
  created() {
    this.getFolderList();
    this.getOSSConfig();
  },
  methods: {
    securityAll() {
      const ids = [];
      this.fileInfoList.map(item => {
        ids.push(item.id);
      });

      this.checkList = ids;
      this.securityShow = true;
    },
    wakeAdjust() {
      this.checkList = [this.detailData.id];
      this.securityShow = true;
    },
    async applySecurity() {
      const loading = this.$loading({
        lock: true,
        text: "执行保密操作中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const data = await securityFile({
        ids: this.checkList,
        secrecy: this.toolsIndex === 1 ? 0 : 1,
        type: this.securityTime ? 1 : 0,
        end_time: this.securityTime ? this.securityTime : ""
      });
      this.$nextTick(() => {
        loading.close();
      });
      if (data.code === 200) {
        this.securityShow = false;
        this.$message.success("执行保密操作成功");
        this.oldDetail.id && this.openDetail(this.oldDetail);
        this.getFolderList(
          this.folderIndexList[this.folderIndexList.length - 1].index
        );
      } else {
        this.$message.warning("执行保密操作失败");
      }
    },
    changeButtonIndex(index) {
      this.toolsIndex = index;
    },
    openSecurity() {
      this.securityShow = true;
    },
    refreshImageDetail() {
      this.openDetail(this.detailData);
      this.getFolderList(
        this.folderIndexList[this.folderIndexList.length - 1].index
      );
    },
    closeProcessList() {
      this.processShow = false;
    },
    async getAllFileList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const data = await getAllFileList();
      this.$nextTick(() => {
        loading.close();
      });
      if (data.code === 200) {
        data.data.data.map(item => {
          item.is_file = true;
        });
        this.folderList = data.data.data;
      }
    },
    async downloadFile() {
      const fileId = this.checkList[0];
      const data = await downloadFile(fileId);
      if (data.code === 200) {
        this.filePath = data.data;
        this.$nextTick(() => {
          this.$refs.fileDownload.click();
        });
      }
    },
    checkSuffix(file, fileList) {
      console.log(file);
      console.log(fileList);
    },
    async getOSSConfig() {
      const [err, data] = await PromiseWidget.to(getOSSConfig());
      if (data.code === 200) {
        this.OSSConfig = data.data;
      } else {
        this.$message.error("初始化上传信息失败,请重试");
      }
    },
    getSuffix(str) {
      return str.lastIndexOf(".") > -1
        ? str.substring(str.lastIndexOf("."))
        : str;
    },
    getFile() {
      this.processShow = true;
      const files = [...this.$refs.uploadFile.files];
      const fileInfoList = JSON.parse(JSON.stringify(this.fileInfoList));
      for (let i = 0; i < files.length; i++) {
        const item = files[i];
        const suffix = this.getSuffix(item.name).toLowerCase();
        item.process = 0;
        if (!UPLOAD_ALLOW_SUFFIX_LIST.includes(suffix)) {
          this.$message.error("文件格式不正确!");
          files.splice(i, 1);
          i--;
        } else {
          fileInfoList.unshift({
            size: item.size,
            name: item.name,
            process: 0,
            fail: false,
            success: false
          });
        }
      }
      this.fileInfoList = JSON.parse(JSON.stringify(fileInfoList));
      this.fileList = files;

      this.uploadFile();
    },
    uploadFile(payload) {
      if (this.OSSConfig.accessKeyId) {
        const folderIndex = [];
        this.folderIndexList.map(item => {
          item.index !== -1 && folderIndex.push(item.name);
        });
        const folderPath = folderIndex.join("/")
          ? folderIndex.join("/") + "/"
          : "";
        this.fileList.map(async (item, index) => {
          const element = this.fileInfoList[index];
          const fileName = item.name
            .replace(/\+/gi, "_")
            .replace(/\%/gi, "_")
            .replace(/\#/gi, "_");
          const [err, data] = await PromiseWidget.to(
            uploadFileToOSS(
              this.OSSConfig,
              item,
              folderPath,
              fileName,
              event => {
                element.process = ((event.loaded / event.total) * 100).toFixed(
                  2
                );
              }
            )
          );

          if (err) {
            element.fail = true;
          } else {
            const filePath = `http://${this.OSSConfig.bucketName}.${this.OSSConfig.endpoint}/${folderPath}${fileName}`;
            const [e, result] = await PromiseWidget.to(
              writeUploadLog(filePath)
            );
            if (result.code === 200) {
              element.success = true;
              element.id = result.data[0];
              this.getFolderList(
                this.folderIndexList[this.folderIndexList.length - 1].index
              );
            }
          }
        });
      } else {
        this.$message.error("初始化上传信息失败,请重试");
      }
    },
    upload() {
      this.$refs.uploadFile.click();
    },
    deleteFileAndFolder() {
      this.$confirm(`确定要删除吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const folderIds = [],
            fileIds = [];
          this.folderList.map(item => {
            if (this.checkList.includes(item.id)) {
              item.is_file ? fileIds.push(item.id) : folderIds.push(item.id);
            }
          });
          const [err, data] = await PromiseWidget.to(
            deleteFileAndFolder({
              folderIds: folderIds.join(","),
              fileIds: fileIds.join(",")
            })
          );
          if (data.code === 200) {
            this.$message.success("删除成功");
            this.getFolderList(
              this.folderIndexList[this.folderIndexList.length - 1].index
            );
            // this.folderIndexList = [];
            this.checkList = [];
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    async getFolderList(index = -1) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const [err, data] = await PromiseWidget.to(getFolderList(index));
      this.$nextTick(() => {
        loading.close();
      });
      if (data.code === 200) {
        data.data.map(item => {
          item.isCheck = false;
        });
        if (this.detailData.id) {
          data.data.map(item => {
            if (item.id === this.detailData.id) {
              this.detailData = JSON.parse(JSON.stringify(item));
            }
          });
        }
        this.checkList = [];
        this.folderList = data.data;
      }
    },
    async backIndex(item, index) {
      if (index < this.folderIndexList.length - 1) {
        const loading = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        const [err, data] = await PromiseWidget.to(getFolderList(item.index));
        this.$nextTick(() => {
          loading.close();
        });
        if (data.code === 200) {
          this.folderId = item.index;
          this.folderIndexList = this.folderIndexList.slice(0, index + 1);
          this.folderList = data.data;
          this.checkList = [];
        }
      }
    },
    async toFolder(item) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const [err, data] = await PromiseWidget.to(getFolderList(item.id));
      this.$nextTick(() => {
        loading.close();
      });
      if (data.code === 200) {
        this.folderIndexList.push({ name: item.menuName, index: item.id });
        this.folderList = data.data;
        this.checkList = [];
        this.checkAll = false;
        this.folderId = item.id;
      }
    },
    async openDetail(item) {
      this.oldDetail = JSON.parse(JSON.stringify(item));
      const [err, data] = await PromiseWidget.to(getFileDetail(item.id));
      if (data.code === 200) {
        this.detailData = data.data;
        this.detailShow = true;
      } else {
        this.$message.error("获取文件详情失败");
      }
    },
    selectAll() {
      const temp = [];
      if (this.checkAll) {
        this.folderList.map(item => {
          item.isCheck = true;
          temp.push(item.id);
        });
      } else {
        this.folderList.map(item => {
          item.isCheck = false;
        });
      }

      this.checkList = temp;
    },
    changeCheckAll() {
      this.checkAll = this.checkList.length === this.folderList.length;
    },
    checkStatus(item) {
      this.$set(item, "isCheck", this.checkList.includes(item.id));
    }
  }
};
</script>
<style lang="scss" scoped>
.folder-main {
  padding: 20px 24px;
  height: 100%;
  box-sizing: border-box;
  .folder-index {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 20px;
    .index-item {
      color: #1983f9;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 10px;
      span {
        width: 12px;
        height: 12px;
        background: url(../assets/images/folder-index-icon.png) no-repeat;
        margin-left: 10px;
      }
      &:last-child {
        color: #606266;
        margin-right: 0;
      }
    }
  }

  .folder-count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 10px;
    border-bottom: 1px solid #dcdfe6;
    height: 32px;

    .el-button {
      font-size: 14px;
    }

    .tools {
      .el-button {
        margin-left: 10px;
      }
    }
  }

  .overflow {
    height: 100%;
    overflow-y: auto;
  }

  .folder-list {
    height: calc(100% - 20px);
  }

  .folder-main-list,
  .image-main-list {
    height: calc(100% - 83px);
    .el-checkbox-group {
      padding-top: 30px;
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .folder-item,
      .image-item {
        width: 120px;
        height: 130px;
        padding: 20px 0;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        margin: 0 20px 20px 0;

        &>img {
          max-width: 100%;
          max-height: 100%;
        }

        &.security .image-box {
          position: relative;
          &:after {
            content: " ";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: url(../assets/images/lock-icon.png) no-repeat center
              center rgba(0, 0, 0, 0.5);
          }
        }

        i.label {
          font-size: 12px;
          color: #fff;
          font-style: normal;
          background-color: #ff6029;
          padding: 0 4px;
          height: 16px;
          line-height: 16px;
          position: absolute;
          left: 6px;
          top: 6px;
        }

        .el-checkbox {
          display: none;
          position: absolute;
          right: 6px;
          top: 6px;
        }
        &:hover,
        &.active {
          background-color: #f4f4f4;
          .el-checkbox {
            display: block;
          }
        }

        p {
          cursor: pointer;
          width: 100%;
          color: #303133;
          font-size: 16px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 10px 0 0;
          padding: 0 10px;
          box-sizing: border-box;
          &:hover {
            color: #1983f9;
          }
        }
      }

      .image-item {
        .image-box {
          width: 60px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          img {
            display: block;
            max-width: 100%;
            max-height: 100%;
          }
        }
        &:hover {
          background-color: #f4f4f4;
        }
      }
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    z-index: 1999;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .security-box {
      width: 600px;
      background-color: #fff;
      border-radius: 5px;
      .title {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #dcdfe6;
        text-align: left;
        padding: 0 20px;
        color: #606266;
        font-size: 14px;
        font-weight: 400;
        margin: 0;
      }

      .security-main {
        padding: 20px 0 30px;
        .setting-box {
          margin-top: 20px;
          image {
            display: block;
          }
          .setting-tools {
            display: flex;
            justify-content: center;
            align-items: center;

            .tools-button {
              width: 76px;
              height: 32px;
              border: 1px solid #d9d9d9;
              border-radius: 5px;
              line-height: 32px;
              box-sizing: border-box;
              cursor: pointer;
              &.active {
                background-color: #f5222d;
                color: #fff;
                border-color: #f5222d;
              }
              &:last-child {
                margin-left: 50px;

                &.active {
                  border-color: #36c626;
                  background-color: #36c626;
                }
              }
            }
          }
          .time-box {
            margin-top: 20px;
            p {
              color: #606266;
              font-size: 14px;
              margin: 0 auto 4px;
              text-align: left;
              width: 240px;
            }
            .el-input {
              width: 240px;
            }
          }
        }
      }

      .tools {
        padding: 10px 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-top: 1px solid #dcdfe6;
      }
    }
  }
}
</style>